module.exports = __webpack_public_path__ + "static/20-e1ef59022bc98b097fe89f16516d0473.jpeg";